import CellphoneFormatter from '../utils/CellphoneFormatter';

export default function formatCellphone(cellphone) {
  return CellphoneFormatter.format(cellphone);
}
